import React from "react";
import Chart from "react-apexcharts";
import CountUp from 'react-countup';

import { WeeklyChart } from "./Components/WeeklyChart";
import { ExpenseChart } from "./Components/ExpenseChart";
import { creditCardData } from "./Components/CreditCardData";
import { SliderData } from "./Components/SliderData";
import { BalanceChart } from "./Components/BalanceChart";
import MySlider from "./Components/Slider";
import { Link } from "react-router-dom";

const Index = () => {
  return (
    <div>
      {/* x---------------------------------x My Cards OR Recent Transaction Section  x---------------------------------x */}
      <div className="row g-sm-3 g-1 row-deck">
        {/* // x---------------------------------x ATM Card x---------------------------------x */}
        {creditCardData.map((cardData, index) => {
          return (
            <div className="col-xl-4 col-md-6" key={index}>
              <div className="card rounded-4 mt-0">
                <div className={`card-header ${cardData.h_class}`}>
                  {
                    cardData.id === 0 ? (
                      <h3 className={`fs-5 fw-semibold`}>{cardData.heading}</h3>
                    ) : (
                      <Link to="/credit-cards" className={`fs-5 fw-semibold`}>See All</Link>
                    )
                  }
                </div>
                <div
                  className={`${cardData.bg_color} rounded-4 mb-3 mb-sm-0`}
                >
                  <div className="card-body rounded-4 rounded-bottom-0">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h5
                          className={`${cardData.text_color} card-title fs-6 fw-normal font-family-Lato`}
                        >
                          Balance
                        </h5>
                        <span
                          className={`${cardData.text_color} card-text fs-3 fw-normal font-family-Lato`}
                        >
                          $ <CountUp end={cardData.value} duration={2.5} start={0} />
                        </span>
                      </div>
                      <div>
                        <div className="card-img">
                          {cardData.cardIcon}
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-4">
                      <div>
                        <h5
                          className={`${cardData.text_color} fs-6 fw-normal font-family-Lato`}
                        >
                          CARD HOLDER
                        </h5>
                        <h4
                          className={`${cardData.text_color} ${cardData.fontsSize}  fw-normal font-family-Lato`}
                        >
                          {cardData.name}
                        </h4>
                      </div>
                      <div>
                        <h5
                          className={`${cardData.text_color} text-opacity-75 fs-6 fw-normal font-family-Lato`}
                        >
                          VALID THRU
                        </h5>
                        <h4
                          className={`${cardData.text_color} fs-3 fw-normal font-family-Lato`}
                        >
                          {cardData.expiry}
                        </h4>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer rounded-bottom-4">
                    <div className="d-flex justify-content-between align-items-center py-2">
                      <div>
                        <h4
                          className={`${cardData.text_color} card-text fs-3 fw-normal font-family-Lato`}
                        >
                          {cardData.cardNumber}
                        </h4>
                      </div>
                      <div>
                        <div className="card-img">
                          {cardData.f_icon}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {/* // x---------------------------------x Recent Transaction card x---------------------------------x */}
        <div className="col-xl-4 col-md-6">
          <div className="card h-100">
            <div className="card-header">
              <h3 className="text-dark fs-5 fw-semibold ">
                Recent Transaction
              </h3>
            </div>
            <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
              <div className="d-flex align-items-center py-1">
                <div className="avatar lg d-flex justify-content-center align-items-center rounded-circle me-2 bg-orenge-lite">
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.318 17.5781H4.05703C3.56136 17.5776 3.08614 17.3805 2.73564 17.03C2.38515 16.6795 2.18802 16.2043 2.1875 15.7086V10.1816C2.18802 9.68596 2.38515 9.21074 2.73564 8.86025C3.08614 8.50975 3.56136 8.31262 4.05703 8.3121H13.318C13.8136 8.31262 14.2889 8.50975 14.6394 8.86025C14.9898 9.21074 15.187 9.68596 15.1875 10.1816V15.7086C15.187 16.2043 14.9898 16.6795 14.6394 17.03C14.2889 17.3805 13.8136 17.5776 13.318 17.5781ZM4.05703 9.48398C3.87206 9.48419 3.69473 9.55775 3.56394 9.68855C3.43315 9.81934 3.35958 9.99667 3.35938 10.1816V15.7086C3.35958 15.8936 3.43315 16.0709 3.56394 16.2017C3.69473 16.3325 3.87206 16.406 4.05703 16.4062H13.318C13.5029 16.406 13.6803 16.3325 13.8111 16.2017C13.9418 16.0709 14.0154 15.8936 14.0156 15.7086V10.1816C14.0154 9.99667 13.9418 9.81934 13.8111 9.68855C13.6803 9.55775 13.5029 9.48419 13.318 9.48398H4.05703Z"
                      fill="#FFBB38"
                    ></path>
                    <path
                      d="M15.9439 14.4227H14.6018C14.4464 14.4227 14.2973 14.3609 14.1874 14.251C14.0776 14.1412 14.0158 13.9921 14.0158 13.8367C14.0158 13.6813 14.0776 13.5323 14.1874 13.4224C14.2973 13.3125 14.4464 13.2508 14.6018 13.2508H15.9439C16.1288 13.2504 16.3059 13.1767 16.4365 13.0459C16.5672 12.9152 16.6406 12.738 16.6408 12.5531V7.02617C16.6407 6.84127 16.5673 6.66396 16.4367 6.53311C16.306 6.40225 16.1288 6.32854 15.9439 6.32812H6.68301C6.49804 6.32833 6.32071 6.4019 6.18992 6.53269C6.05913 6.66348 5.98556 6.84081 5.98535 7.02578V8.89766C5.98535 9.05306 5.92362 9.20209 5.81373 9.31198C5.70385 9.42186 5.55481 9.48359 5.39941 9.48359C5.24401 9.48359 5.09498 9.42186 4.98509 9.31198C4.87521 9.20209 4.81348 9.05306 4.81348 8.89766V7.02617C4.81389 6.53043 5.01098 6.05511 5.36148 5.70453C5.71199 5.35395 6.18727 5.15677 6.68301 5.15625H15.9439C16.4395 5.15697 16.9146 5.35425 17.265 5.70481C17.6153 6.05536 17.8123 6.53057 17.8127 7.02617V12.5531C17.8122 13.0487 17.6152 13.5238 17.2648 13.8742C16.9145 14.2247 16.4395 14.4219 15.9439 14.4227Z"
                      fill="#FFBB38"
                    ></path>
                    <path
                      d="M14.6016 13.3902H2.77344C2.61804 13.3902 2.469 13.3285 2.35912 13.2186C2.24923 13.1087 2.1875 12.9597 2.1875 12.8043V10.8363C2.1875 10.6809 2.24923 10.5319 2.35912 10.422C2.469 10.3121 2.61804 10.2504 2.77344 10.2504H14.6016C14.757 10.2504 14.906 10.3121 15.0159 10.422C15.1258 10.5319 15.1875 10.6809 15.1875 10.8363V12.8043C15.1875 12.9597 15.1258 13.1087 15.0159 13.2186C14.906 13.3285 14.757 13.3902 14.6016 13.3902ZM3.35938 12.2183H14.0156V11.4222H3.35938V12.2183Z"
                      fill="#FFBB38"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h5 className="card-title fs-6fw-medium ">
                    Deposit from my
                  </h5>
                  <h4 className="card-text text-secondary fs-6 fw-normal ">
                    28 January 2021
                  </h4>
                </div>
                <div className="ms-auto">
                  <h4 className="card-text text-success fs-6 fw-medium ">
                    $
                    <span className="card-text text-success fs-6 fw-medium">
                      <CountUp end={850} duration={2.5} start={0} />
                    </span>
                  </h4>
                </div>
              </div>
              <div className="d-flex align-items-center py-4">
                <div className="avatar lg text-center rounded-circle me-2 bg-blue-lite d-flex justify-content-center align-items-center">
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.4249 5.98748C16.415 4.89442 15.9743 3.8494 15.1985 3.07939C14.4226 2.30938 13.3743 1.87658 12.2812 1.87498H6.24992C6.10012 1.87305 5.9546 1.925 5.83988 2.02136C5.72517 2.11772 5.64888 2.25208 5.62492 2.39998L3.48742 15.8062C3.47407 15.895 3.47999 15.9856 3.5048 16.0719C3.52961 16.1582 3.57271 16.2381 3.63117 16.3062C3.68926 16.376 3.76184 16.4322 3.84387 16.4711C3.9259 16.5099 4.01541 16.5305 4.10617 16.5312H6.68742L6.54992 17.4C6.53532 17.49 6.5406 17.5822 6.5654 17.6699C6.59021 17.7577 6.63392 17.839 6.69348 17.9081C6.75304 17.9772 6.827 18.0324 6.91018 18.0699C6.99335 18.1073 7.08371 18.1262 7.17492 18.125H10.0812C10.2301 18.1271 10.3748 18.0761 10.4894 17.981C10.604 17.8859 10.6809 17.753 10.7062 17.6062L11.3312 13.7875H13.2999C14.5322 13.7825 15.7123 13.29 16.5825 12.4175C17.4526 11.545 17.942 10.3635 17.9437 9.13123V8.95623C17.943 8.37659 17.8051 7.80535 17.5411 7.28932C17.2771 6.77329 16.8946 6.32716 16.4249 5.98748ZM6.78117 3.12498H12.2812C12.9369 3.12699 13.5726 3.35117 14.0845 3.76093C14.5964 4.1707 14.9544 4.74186 15.0999 5.38123C14.8295 5.31781 14.5526 5.28635 14.2749 5.28748H9.06242C8.91262 5.28555 8.7671 5.3375 8.65238 5.43386C8.53767 5.53022 8.46138 5.66458 8.43742 5.81248L8.06867 8.12498C8.04215 8.29074 8.08256 8.46024 8.18102 8.59621C8.27948 8.73217 8.42791 8.82345 8.59367 8.84998C8.75943 8.8765 8.92894 8.83608 9.0649 8.73763C9.20087 8.63917 9.29215 8.49074 9.31867 8.32498L9.60617 6.52498H14.2874C14.587 6.52655 14.8837 6.58377 15.1624 6.69373C15.0436 7.67213 14.5716 8.57346 13.835 9.22833C13.0984 9.88319 12.148 10.2465 11.1624 10.25H8.26242C8.11353 10.2478 7.96875 10.2989 7.85417 10.394C7.73958 10.4891 7.66272 10.622 7.63742 10.7687L6.87492 15.2812H4.83742L6.78117 3.12498ZM16.6937 9.13123C16.692 10.032 16.3344 10.8955 15.6986 11.5336C15.0629 12.1717 14.2006 12.5325 13.2999 12.5375H10.7999C10.651 12.5353 10.5063 12.5864 10.3917 12.6815C10.2771 12.7766 10.2002 12.9095 10.1749 13.0562L9.54992 16.875H7.89992L8.03742 16.0062L8.78742 11.5125H11.1499C12.3167 11.509 13.4496 11.1198 14.3721 10.4053C15.2945 9.69085 15.9548 8.69132 16.2499 7.56248C16.54 7.96919 16.6952 8.45666 16.6937 8.95623V9.13123Z"
                      fill="#396AFF"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h5 className="card-title fs-6fw-medium ">
                    Deposit Paypal
                  </h5>
                  <h4 className="card-text text-secondary fs-6 fw-normal ">
                    25 January 2021
                  </h4>
                </div>
                <div className="ms-auto">
                  <h4 className="card-text text-danger fs-6 fw-medium">
                    <span className="card-text text-danger fs-6 fw-medium">
                      <CountUp end={2500} duration={2.5} start={0} prefix="$" />
                    </span>
                  </h4>
                </div>
              </div>
              <div className="d-flex align-items-center py-1">
                <div className="avatar lg text-center rounded-circle bg-teal-lite me-2 d-flex justify-content-center align-items-center">
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.0002 8.12787C10.3546 8.12787 10.644 8.41651 10.644 8.77086C10.644 9.0942 10.9068 9.35627 11.2301 9.35627C11.5527 9.35627 11.8155 9.0942 11.8155 8.77086C11.8155 7.97653 11.298 7.30622 10.5856 7.06113V6.72893C10.5856 6.40633 10.3236 6.14278 10.0002 6.14278C9.67616 6.14278 9.41409 6.40633 9.41409 6.72893V7.06113C8.7017 7.30622 8.18568 7.97653 8.18568 8.77086C8.18568 9.77263 8.9992 10.5862 10.0002 10.5862C10.3546 10.5862 10.644 10.8755 10.644 11.2299C10.644 11.585 10.3546 11.8736 10.0002 11.8736C9.64589 11.8736 9.35724 11.585 9.35724 11.2299C9.35724 10.9065 9.09443 10.6437 8.77109 10.6437C8.44701 10.6437 8.18568 10.9065 8.18568 11.2299C8.18568 12.0242 8.7017 12.6938 9.41409 12.9389V13.2711C9.41409 13.5952 9.67616 13.858 10.0002 13.858C10.3236 13.858 10.5856 13.5952 10.5856 13.2711V12.9389C11.298 12.6938 11.8155 12.0242 11.8155 11.2299C11.8155 10.2289 11.0013 9.41459 10.0002 9.41459C9.64589 9.41459 9.35724 9.12595 9.35724 8.77086C9.35724 8.41651 9.64589 8.12787 10.0002 8.12787ZM14.9087 13.2534C15.1959 13.4047 15.5495 13.2947 15.7001 13.0098C16.1873 12.0892 16.4442 11.0483 16.4442 10C16.4442 6.44767 13.5526 3.55678 10.0002 3.55678C6.44716 3.55678 3.55627 6.44767 3.55627 10C3.55627 13.5531 6.44716 16.444 10.0002 16.444C11.033 16.444 12.0591 16.1945 12.9679 15.7213C13.2551 15.5729 13.3665 15.2178 13.2174 14.9314C13.0683 14.6457 12.7147 14.532 12.4268 14.6818C11.6745 15.0746 10.8573 15.2732 10.0002 15.2732C7.09311 15.2732 4.72709 12.9079 4.72709 10C4.72709 7.09361 7.09311 4.7276 10.0002 4.7276C12.9074 4.7276 15.2734 7.09361 15.2734 10C15.2734 10.8586 15.0622 11.7097 14.6651 12.4613C14.513 12.7477 14.6223 13.102 14.9087 13.2534V13.2534ZM10.0002 1.21217C8.30306 1.21217 6.65534 1.69793 5.23573 2.61554C4.96333 2.79124 4.88581 3.15371 5.06151 3.42537C5.23795 3.69704 5.59894 3.77381 5.87208 3.59959C7.10049 2.80526 8.52969 2.38448 10.0002 2.38448C14.2 2.38448 17.6158 5.80098 17.6158 10C17.6158 14.1998 14.2 17.6163 10.0002 17.6163C5.80047 17.6163 2.38397 14.1998 2.38397 10C2.38397 8.54349 2.79663 7.12683 3.57841 5.90507C3.75264 5.63193 3.67291 5.26946 3.39976 5.09524C3.12736 4.92102 2.76489 5.00075 2.59141 5.27315C1.6893 6.6839 1.2124 8.31981 1.2124 10C1.2124 14.8465 5.15379 18.7878 10.0002 18.7878C14.8459 18.7878 18.7881 14.8465 18.7881 10C18.7881 5.15504 14.8459 1.21217 10.0002 1.21217V1.21217Z"
                      fill="#16DBCC"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h5 className="card-title fs-6fw-medium ">Jemi Wilson</h5>
                  <h4 className="card-text text-secondary fs-6 fw-normal ">
                    21 January 2021
                  </h4>
                </div>
                <div className="ms-auto">
                  <h4 className="card-text text-danger fs-6 fw-medium">
                    <span className="card-text text-danger fs-6 fw-medium">
                      <CountUp end={5400} duration={2.5} start={0} prefix="$" />
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*  // x---------------------------------x lg-layout x---------------------------------x */}
        <div className="col-md-6 d-none d-md-block d-xl-none">
          <div className="card  h-100">
            <div className="card-header justify-content-between">
              <h3 className="text-dark fs-5 fw-semibold ">
                Expense Statistics
              </h3>
            </div>
            <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white d-flex align-items-center">
              <div id="chart-two weekly_chart">
                <Chart
                  options={ExpenseChart}
                  series={ExpenseChart.series}
                  type={ExpenseChart.chart.type}
                  height={ExpenseChart.chart.height}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* x---------------------------------x Weekly Activity OR Expense Statistics Section x---------------------------------x */}
      <div className="row my-2 g-3 row-deck">
        {/* <!-- Weekly Activity --> */}
        <div className="col-xl-8 col-md-12">
          <div className="card  h-100 w-100">
            <div className="card-header justify-content-between">
              <h3 className="text-dark fs-5 fw-semibold ">Weekly Activity</h3>
            </div>
            <div className="card-body rounded-4 mb-3 mb-sm-0 bg-light">
              <div id="chart-two weekly_chart" className="text-dark">
                <Chart
                  options={WeeklyChart}
                  series={WeeklyChart.series}
                  type={WeeklyChart.chart.type}
                  height={WeeklyChart.chart.height}
                />
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Expense Statistics --> */}
        <div className="col-sm-4 d-sm-none d-xl-block">
          <div className="card  h-100">
            <div className="card-header justify-content-between">
              <h3 className="text-dark fs-5 fw-semibold ">
                Expense Statistics
              </h3>
            </div>
            <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white d-flex align-items-center">
              <div style={{ width: "100%", minHeight: "inherit" }} id="chart-two-xl">
                <Chart
                  options={ExpenseChart}
                  series={ExpenseChart.series}
                  type={ExpenseChart.chart.type}
                  height={ExpenseChart.chart.height}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* x---------------------------------x Quick Transfer OR Balance History Section x---------------------------------x */}
      <div className="row my-2 g-3 row-deck">
        {/* x---------------------------------x Quick Transfer x---------------------------------x */}
        <div className="col-xl-5 col-md-6">
          <div className="card  h-100">
            <div className="card-header justify-content-between">
              <h3 className="text-dark fs-5 fw-semibold ">Quick Transfer</h3>
            </div>
            <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
              <div className="carousel row g-1 m-0">
                <div className="col-10 panel">
                  {/* Slider Section Start */}
                  <MySlider SliderData={SliderData} />
                  {/* Slider Section End */}
                </div>
                <div className="row justify-content-between py-3 col-12 panel align-items-center">
                  <div className="col-sm-4">
                    <div className="mb-3 pb-3">
                      <span className="fs-6 fw-normal  m-0 py-2 text-muted">
                        Write Amount
                      </span>
                    </div>
                  </div>
                  <div className="col-sm-8 carousel-button position-relative pb-3">
                    <div className="input-group d-flex align-items-center mb-3 rounded-5 bg-light">
                      <input
                        type="text"
                        className="form-control form-control-md px-2 rounded-5 bg-light border-0"
                        placeholder="525.50"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                      />
                      <span
                        className="input-group-text bg-primary rounded-5 "
                        id="basic-addon2"
                      >
                        <span className="me-2 text-white py-1 px-3">
                          send
                        </span>
                        <svg
                          width="17"
                          height="14"
                          viewBox="0 0 17 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.0963 0.572034C16.1748 0.206511 15.8164 -0.101694 15.4669 0.0316926L0.303581 5.82017C0.121087 5.88985 0.000378397 6.06476 8.88017e-07 6.26009C-0.000376621 6.45546 0.11964 6.63084 0.301883 6.70121L4.56154 8.34637V13.5281C4.56154 13.7467 4.71163 13.9366 4.9243 13.9872C5.13554 14.0374 5.35582 13.9369 5.45485 13.7404L7.2166 10.2445L11.5159 13.4351C11.7774 13.6292 12.1533 13.5058 12.2485 13.1939C16.2627 0.0327312 16.0891 0.605098 16.0963 0.572034ZM12.3532 2.2305L4.96655 7.49106L1.78829 6.26359L12.3532 2.2305ZM5.50531 8.26599L11.944 3.6806C6.4036 9.52539 6.69296 9.21775 6.6688 9.25028C6.6329 9.29857 6.73125 9.11035 5.50531 11.5431V8.26599ZM11.541 12.2785L7.75659 9.46993L14.5993 2.25126L11.541 12.2785Z"
                            fill="white"
                          ></path>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* x---------------------------------x Balance History x---------------------------------x */}
        <div className="col-xl-7 col-md-6">
          <div className="card  h-100">
            <div className="card-header justify-content-between">
              <h3 className="text-dark fs-5 fw-semibold ">Balance History</h3>
            </div>
            <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
              <div
                style={{ width: "100%", height: "261px" }}
                id="chart-three"
              >
                <Chart
                  options={BalanceChart}
                  series={BalanceChart.series}
                  type={BalanceChart.chart.type}
                  height={BalanceChart.chart.height}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Index;
